export default __webpack_public_path__ + "static/media/la2mg.b9f2fa53.svg";